<template>
    <div>
        <div id="app" :class="vueAppClasses">
            <router-view @setAppClasses="setAppClasses"/>
        </div>
    </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';
import "@/assets/scss/vuexy/extraComponents/tree.scss";
import {constAPI} from "./store/constant";

export default {
    data() {
        return {
            vueAppClasses: [],
        }
    },
    watch: {
        '$store.state.theme'(val) {
            this.toggleClassInBody(val)
        },
        '$vs.rtl'(val) {
            document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
        }
    },
    methods: {
        toggleClassInBody(className) {
            if (className === 'dark') {
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
                document.body.classList.add('theme-dark')
            } else if (className === 'semi-dark') {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                document.body.classList.add('theme-semi-dark')
            } else {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
            }
        },
        setAppClasses(classesStr) {
            this.vueAppClasses.push(classesStr)
        },
        handleWindowResize() {
            this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

            // Set --vh property
            document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
        },
        handleScroll() {
            this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
        },
        getRole(role) {
            switch (role) {
                case 'ROLE_ADMIN':
                    return 'admin';
                case 'ROLE_ADMIN_ORGANIZATION':
                    return 'organization';
                case 'ROLE_ADMIN_ORGANIZATION_BRANCH':
                    return 'organization_branch';
                default:
                    return 'user';
            }
        },
        redirectToHomePage(userRole) {
            let login = window.location.href.includes('login');
            let work_space = window.location.href.includes('select-work-space');
            if (((login || work_space) && userRole === 'organization') || ((login || work_space) && userRole === 'user') || ((login || work_space) && userRole === 'organization_branch')) {
                let space = localStorage.getItem('work_space');
                if (space === 'hrm') return this.$router.push('/dashboard-hrm').catch(() => {
                });
                if (space === 'crm') return this.$router.push('/dashboard-crm').catch(() => {
                });
            }

            if (window.location.href.includes('login') && userRole === 'admin')
                return this.$router.push('/admin/manage-organization').catch(() => {
                });
        },
        checkUserHasLoggedIn: async function () {
            let token = localStorage.getItem('access_token');
            let space = localStorage.getItem('work_space');
            let isChat = localStorage.getItem('isChat');
            if (!token && !space && !window.location.href.includes("guide") && !window.location.href.includes("login") && !window.location.href.includes("register"))
                return this.$router.push('/pages/select-work-space').catch(() => {
                });

            let that = this;
            this.$vs.loading();
            await this.$oauth.get('/user/current').then((response) => {
                this.$vs.loading.close();
                let userInfo = response.data;
                let href = window.location.href
                if (!userInfo)
                    return window.location = '/pages/login';
                if (userInfo.activeStatus == 0 && !href.includes('active') && !href.includes("active-email")) return this.$router.push('/pages/active-email?email=' + userInfo.email).catch(() => {
                });
                userInfo.userRole = this.getRole(userInfo.roles[0].role);
                this.$acl.change(userInfo.userRole)
                that.$store.dispatch('updateUserInfo', userInfo);
                if (userInfo.userRole === 'admin') return this.redirectToHomePage(userInfo.userRole);

                this.checkPermissionUser(userInfo)
                if (userInfo.userRole == 'user') this.getTokenCall();
                this.$vs.loading.close();

                this.getInfoBranch(userInfo)
                if (token && !space) return this.$router.push('/pages/select-work-space').catch(() => {
                });
                if (token && space && isChat === 'true') return this.$router.push('/user/message').catch(() => {
                });
            }).catch(() => {
                this.$vs.loading.close();
            });
            if (this.$messaging) {
                this.$messaging.requestPermission().then(() => {
                    console.log("Notification permission granted.");
                    return this.$messaging.getToken()
                }).then((token) => {
                    localStorage.setItem("deviceToken", token)
                    this.$crm.post('/notification/subscribe', {tokens: [token]}).then(() => {
                        this.$vs.loading.close();
                    }).catch(() => {
                        this.$vs.loading.close();
                    });
                }).catch(function (err) {
                    console.log("Unable to get permission to notify.", err);
                });
                this.$messaging.onTokenRefresh(() => {
                    this.$messaging.getToken().then((refreshedToken) => {
                        console.log('Token refreshed.');
                        localStorage.setItem("deviceToken", refreshedToken)
                        this.$crm.post('/notification/subscribe', {tokens: [refreshedToken]}).then(() => {
                            this.$vs.loading.close();
                        }).catch(() => {
                            this.$vs.loading.close();
                        });
                    }).catch(() => {
                    });
                });
            }
        },

        getTokenCall() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            let payload = {
                memberNo: userInfo.employeeCode
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/get-sdk-token', payload).then(res => {
                localStorage.setItem("tokenCall", res.data.data);
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        checkPermissionUser(userInfo) {
            localStorage.removeItem("permissions");
            let permissions = [];
            userInfo.positions.forEach(x => {
                permissions.push(...x.permission);
            })
            if (permissions.length == 0 && userInfo.userRole === 'user') {
                localStorage.clear();
                return this.$vs.notify({
                    text: 'Tài khoản không có quyền truy cập!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            localStorage.setItem("permissions", JSON.stringify(permissions));
            this.$store.dispatch('updatePermissionsInfo', permissions);
        },

        getInfoBranch(userInfo) {
            this.$crm.post('/organization-branch/all').then((response) => {
                this.$vs.loading.close();
                this.$store.dispatch('updateBranchListInfo', response.data);
                return this.redirectToHomePage(userInfo.userRole);
            }).catch(() => {
                // localStorage.clear();
                // return this.$router.push('/pages/login').catch(() => {
                // });
            });
        },
    },
    mounted() {
        this.$eventBus.$on("login-success", async () => {
            await this.checkUserHasLoggedIn();
        })
        this.toggleClassInBody(themeConfig.theme);
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    async created() {
        let dir = this.$vs.rtl ? "rtl" : "ltr";
        document.documentElement.setAttribute("dir", dir);
        window.addEventListener('resize', this.handleWindowResize);
        window.addEventListener('scroll', this.handleScroll);

        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (!userInfo) {
            let token = localStorage.getItem('access_token');
            if (token) {
                await this.checkUserHasLoggedIn();
            } else {
                return this.$router.push('/pages/login');
            }
        } else {
            // let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            // if (!branchList) this.getInfoBranch(userInfo)
            this.checkPermissionUser(userInfo);
            if (userInfo.userRole == 'user') {
                let tokenCall = localStorage.getItem('tokenCall');
                let permission = JSON.parse(localStorage.getItem('permissions'));
                let result = permission.find(el => el.functionName == 'PRIVILEGE_VBOT_CUSTOMER_CALL');
                if (result && !tokenCall) this.getTokenCall();
            }
        }
        let space = localStorage.getItem('work_space');
        let href = window.location.pathname;
        if (space === 'hrm' && href === '/') return this.$router.push('/dashboard-hrm');
        if (space === 'crm' && href === '/') return this.$router.push('/dashboard-crm');
        if (!space && href === '/') return this.$router.push('/pages/select-work-space');
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowResize);
        window.removeEventListener('scroll', this.handleScroll);
    },
}

</script>
